module.exports = __webpack_public_path__ + "static/img/avatar.339b6bf5.png";